export const COMMON_LEARN_MORE_URL = 'https://business.coursera.help/hc/articles/000002438';
